import React from 'react'
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatNumber } from '../../../utilities/dashboard'
import ChartTooltip, { BarLabel } from './ChartTooltip'
import { ACTIVE_BAR, axisTick, CHART_DESC } from './DailyChart'
import useChartColors from './useChartColors'

const tooltipFor = (row, colors) => ({
  title: row.title,
  rows: [{ color: colors.primary, value: formatNumber(row.total), label: row.total === 1 ? 'cadastro' : 'cadastros' }],
  notes: [row.systemStart ? 'início do sistema: inclui quem já era paciente' : '', row.partialTag ? 'mês em andamento' : ''],
})

// Cadastros por mês: um mês por barra, com os meses sem cadastro em zero (o backend preenche). O mês atual leva o rótulo
// "parcial", como no mês a mês da aba Prontuário
const RegistrationsChart = ({ rows, narrow, title }) => {
  const { chart: colors } = useChartColors()
  const labels = Object.fromEntries(rows.map((row) => [row.month, row.label]))
  const step = Math.max(1, Math.ceil(rows.length / (narrow ? 4 : 12)))
  const ticks = rows.filter((_, index) => index % step === 0).map((row) => row.month)
  // O rótulo "parcial" do mês atual, quando é a última barra, passa da borda direita no celular sem essa folga
  const lastPartial = Boolean(rows[rows.length - 1]?.partialTag)

  return (
    <ResponsiveContainer width='100%' height={240}>
      <BarChart data={rows} margin={{ top: 18, right: lastPartial ? 20 : 8, bottom: 0, left: -10 }} accessibilityLayer title={title} desc={CHART_DESC}>
        <CartesianGrid vertical={false} stroke={colors.grid} />
        <XAxis
          dataKey='month'
          tickFormatter={(month) => labels[month] ?? ''}
          ticks={ticks}
          interval={0}
          tickLine={false}
          axisLine={{ stroke: colors.axis }}
          tick={axisTick(colors)}
        />
        <YAxis allowDecimals={false} width={44} tickLine={false} axisLine={false} tick={axisTick(colors)} />
        <Tooltip cursor={{ fill: colors.cursor }} content={<ChartTooltip render={tooltipFor} />} isAnimationActive={false} />
        <Bar dataKey='total' name='Cadastros' fill={colors.primary} radius={[4, 4, 0, 0]} maxBarSize={24} activeBar={ACTIVE_BAR} isAnimationActive={false}>
          <LabelList dataKey='partialTag' content={<BarLabel fontSize={10} fontWeight={600} />} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default RegistrationsChart
